export async function fetchLinkPreview(url) {
  try {
    const response = await fetch(`/api/linkpreview/?q=${encodeURIComponent(url)}`);
    const preview = await response.json();
    console.log(preview);
    return preview;
  } catch (error) {
    console.error('Could not load link preview:', error);
    return null;
  }
}
